import PageData from '../../common/ts/PageData';
import HipflatModalPhotosSection from './HipflatModalPhotosSection'
import HipflatPhotosSection from "./HipflatPhotosSection";
import HipflatListingHighLightSection from "./HipflatListingHighLightSection";
import ProjectUnits from "./common/ProjectUnits";
import ObfuscatedFields from "../../common/ts/forms/ObfuscatedFields";
import HipflatPhoneTracking from "./HipflatPhoneTracking";
import {WebVitalsTracking} from "../../common/ts/WebVitalsTracking";
import HipflatSimilarListings from "./HipflatSimilarListings";
import HipflatInternalStatsTracker from "./common/HipflatInternalStatsTracker";

window.addEventListener("load", () => {
    // @ts-ignore
    const pageData: PageData = window.wl.pageData

    HipflatListingHighLightSection.init();
    HipflatModalPhotosSection.init(pageData);
    HipflatPhotosSection.init(pageData);
    ObfuscatedFields.init(pageData);
    ProjectUnits.init(pageData);

    HipflatPhoneTracking.init(pageData);
    HipflatSimilarListings.init(pageData);

    WebVitalsTracking.init("Detail")
    HipflatInternalStatsTracker.track(pageData)
});
